import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <div className="wg-cls style-circle hover-img">
      <Link
        to={`/brands/${item?.slug || item?.slugPath }`}
        className="image img-style d-block"
      >
        {item?.image && (
          <img src={item?.image} alt="brands" className="lazyload" />
        )}
        <div className="cls-content text-center">
          <span className="link text-md fw-medium">{item?.name}</span>
        </div>
      </Link>
    </div>
  );
}

export default Card;
